import { useState, useEffect } from "react";
import { resolveImg } from "@/lib/api";

// Inline SVG fallback (crescent + tiny moth motif) — matches Golden Moth palette.
const FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'>
  <rect width='400' height='400' fill='#0F1D15'/>
  <g fill='none' stroke='#C5A059' stroke-width='1.2' opacity='0.9'>
    <circle cx='200' cy='150' r='42'/>
    <path d='M175 148 a30 30 0 0 0 58 0' fill='#0F1D15' stroke='none'/>
    <path d='M200 210 q-70 20 -95 65 q30 -10 95 -10 q65 0 95 10 q-25 -45 -95 -65 z'/>
    <line x1='200' y1='205' x2='200' y2='300'/>
    <circle cx='120' cy='90' r='1.5' fill='#C5A059'/>
    <circle cx='300' cy='110' r='1.5' fill='#C5A059'/>
    <circle cx='330' cy='260' r='1.5' fill='#C5A059'/>
    <circle cx='80'  cy='300' r='1.5' fill='#C5A059'/>
  </g>
  <text x='200' y='355' text-anchor='middle' font-family='Georgia,serif' font-size='13' fill='#C5A059' letter-spacing='3'>GOLDEN MOTH</text>
</svg>`);

/**
 * SafeImage — renders <img> with a branded on-brand fallback when the source
 * is missing or fails to load. Never shows the browser's broken-image glyph.
 */
export default function SafeImage({ src, alt = "", className = "", ...rest }) {
  const resolved = src ? resolveImg(src) : FALLBACK;
  const [current, setCurrent] = useState(resolved);
  // Sync displayed image when the src prop changes (e.g. navigating between products)
  useEffect(() => { setCurrent(resolved); }, [resolved]);
  return (
    <img
      src={current}
      alt={alt}
      className={className}
      onError={() => { if (current !== FALLBACK) setCurrent(FALLBACK); }}
      {...rest}
    />
  );
}

export { FALLBACK as FALLBACK_IMG };
